<div mat-dialog-title markdown [data]="title" class="markdown-title"></div>
<mat-dialog-content aria-label="Send Email Dialog Content">
  <div class="modal-body">
    <div class="fs-17 mb-2" markdown [data]="content"></div>
    @if (!isSendLink) {
    <div class="form-group mb-1">
      <form [formGroup]="loginFormGroup">
        <label for="emailLbl" class="d-block mb-2 fs-23 text-col3">Email address</label>
        <mat-form-field floatLabel='never' class="w-100 mw424 ctm-input" appearance="fill"
          [ngClass]="!loginFormGroup?.get('email')?.valid && loginFormGroup?.get('email')?.touched ? 'error-bar' : ''">
          <input [id]="id + '_EmailAddress'" type="email" matInput placeholder=""
            class="cy-email inputTyp2 sessioncamexclude sessioncamhidetext maskpii" formControlName="email" #emailRef />
          <mat-error class="ctm-error"
            *ngIf="!loginFormGroup?.get('email')?.valid && loginFormGroup?.get('email')?.touched">
            <span *ngIf="loginFormGroup?.get('email')?.hasError('required')">Email address is required.</span>
            <span
              *ngIf="loginFormGroup?.get('email')?.hasError('pattern') && !loginFormGroup?.get('email')?.hasError('required')">
              Not a valid email address.</span>
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    <div class="text-danger" *ngIf="!!errorMessage">{{ errorMessage }}</div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions class="d-flex flex-column flex-sm-row align-items-stretch gap-2" align="end">
  @if (!isSendLink) {
  @if (!correlationId) {
  <button [id]="id + '_Cancel'" class="btn btn-primary-outline order-2 order-sm-1"
    (click)="cancel('beenHereBefore')">Cancel</button>
  }
  <button [id]="id + '_SendLink'" class="btn btn-primary order-1 order-sm-2" [ngClass]="isLoading ? 'animate' : ''"
    [disabled]="isLoading" (click)="!isLoading ? validateForm('beenHereBefore') : ''">
    <span class="spinner"></span><span class="text">Send link</span>
  </button>
  } @else {
  <button [id]="id + '_Close'" class="btn btn-primary-outline" (click)="cancel('close')">Close</button>
  }
</mat-dialog-actions>